import {HStack, Text, Box} from 'platform/foundation';

import {EMPTY_PLACEHOLDER, Nullish} from 'shared/web';

export interface TableCellProps {
  value: string | number | Nullish;
}

export const TableCell = (props: TableCellProps) => (
  <HStack align="center" height={13}>
    <Box paddingHorizontal={4}>
      <Text size="small">{props.value || EMPTY_PLACEHOLDER}</Text>
    </Box>
  </HStack>
);
